import React, { useState } from "react";
import { MdCloudUpload } from "react-icons/md";

import { useUploadQuestionImageMutation } from "../../slices/questionImageApiSlice";

const QuestionImageUpload = ({ questionId }) => {
  const [uploadQuestionImage, { isLoading }] =
    useUploadQuestionImageMutation();

  const [error, setError] = useState("");

  const handleFileChange = async (event) => {
    const file = event.target.files[0];

    if (!file) return;

    setError("");

    // Validate image type
    if (!file.type.startsWith("image/")) {
      setError("Please select a valid image file");
      return;
    }

    // Validate file size (5 MB)
    if (file.size > 5 * 1024 * 1024) {
      setError("Image size should be less than 5 MB");
      return;
    }

    const formData = new FormData();
    formData.append("image", file);

    try {
      await uploadQuestionImage({
        questionId,
        formData,
      }).unwrap();
    } catch (error) {
      setError(error?.data?.message || "Failed to upload image");
    }
  };

  return (
    <div>
      <label
        className={`inline-flex cursor-pointer items-center gap-2 rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white transition hover:bg-blue-700 ${
          isLoading ? "cursor-not-allowed opacity-60" : ""
        }`}
      >
        {isLoading ? (
          <>
            <svg
              className="h-5 w-5 animate-spin"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              />
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
              />
            </svg>
            Uploading...
          </>
        ) : (
          <>
            <MdCloudUpload className="text-xl" />
            Upload Image
          </>
        )}

        <input
          type="file"
          accept="image/*"
          onChange={handleFileChange}
          disabled={isLoading}
          className="hidden"
        />
      </label>

      {error && (
        <p className="mt-2 text-sm text-red-600">
          {error}
        </p>
      )}
    </div>
  );
};

export default QuestionImageUpload;